import { Button } from "@jhool-io/fe-components";
import { useParams, useSearchParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { usePostPayments } from "../../../hooks/remits.mutations";
import useToast from "../../../../../hooks/useToast";

export default function BulkPostPaymentsAction() {
    const [searchParams, setSearchParams] = useSearchParams();
    const { noteId, clientId } = useParams();
    const { toast } = useToast();
    const queryClient = useQueryClient();
    const postPayments = usePostPayments();

    const paymentsArray = searchParams.getAll("selectedPayments");

    const handlePostPayment = () => {
        postPayments.mutate(
            { payment_ids: paymentsArray },
            {
                onSuccess: (res) => {
                    queryClient.invalidateQueries([
                        "remit-claims",
                        { note_id: noteId },
                    ]);
                    queryClient.invalidateQueries({
                        queryKey: ["get-payment"],
                    });
                    queryClient.invalidateQueries({
                        queryKey: [clientId, `session-note`, noteId],
                    });
                    toast({
                        mode: "success",
                        message:
                            res.message || "Payment(s) posted successfully.",
                    });
                    searchParams.delete("selectedPayments");
                    setSearchParams(searchParams);
                },
                onError: (err) => {
                    toast({
                        mode: "error",
                        message:
                            err.response?.data.message ||
                            "Could not post payment(s).",
                    });
                },
            }
        );
    };

    if (paymentsArray.length === 0) return null;

    return (
        <div className="flex items-center gap-x-1">
            <p className="text-sm font-medium">
                {paymentsArray.length} selected:
            </p>
            <Button
                disabled={postPayments.isLoading}
                onClick={handlePostPayment}
            >
                Confirm payments
            </Button>
        </div>
    );
}
